import { createNextState } from '@reduxjs/toolkit'
import { registerAction } from '../../Action'

const REMOVE_JSONAPIENTITY_RELATIONSHIP = 'REMOVE_JSONAPIENTITY_RELATIONSHIP'

const reducer = (state = {}, action) => {
  const {
    primaryResourceType,
    primaryResourceId,
    relationshipType,
    relationshipId,
  } = action.payload

  const primaryResource =
    state.jsonApiEntities[primaryResourceType][primaryResourceId]
  const updatedResource = createNextState(primaryResource, (draftResource) => {
    let relationshipResource = draftResource.relationships[relationshipType]

    // If the relationship is empty or null, we have nothing to delete so return the state as-is.
    if (
      relationshipResource === null ||
      (Array.isArray(relationshipResource) && relationshipResource.length === 0)
    ) {
      return
    }

    // If the relationship is an array, filter out the target id and return
    if (Array.isArray(relationshipResource)) {
      const newRelationships = relationshipResource.filter(
        (rel) => rel.id !== relationshipId
      )
      draftResource.relationships[relationshipType] = newRelationships

      // This is a bit of special logic to update a Moment's postCount.
      // This is usually managed by the decorators when run through the deserializer,
      // but we don't want or need access to the deserializer for this reducer.
      if (primaryResourceType === 'moment' && relationshipType === 'posts') {
        draftResource.postCount = newRelationships.length
      }

      return
    }

    // If the relationship is an object, confirm that our ID matches and set the object to null.
    if (relationshipResource.id === relationshipId) {
      draftResource.relationships[relationshipType] = null
      return
    }
  })

  return {
    ...state,
    jsonApiEntities: {
      ...state.jsonApiEntities,
      [primaryResourceType]: {
        ...state.jsonApiEntities[primaryResourceType],
        [primaryResourceId]: updatedResource,
      },
    },
  }
}

export const removeJsonApiEntityRelationship = registerAction(
  REMOVE_JSONAPIENTITY_RELATIONSHIP,
  { reducer }
)
